export default "__VITE_ASSET__BesR$sUg__"